let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import POS from "../../POS.js";

let main = function () {
    return Backbone.View.extend({
        events: {
            "click .note-item": "_selectNote",
            "click .saveNote": "_saveNote",
            "click .delete-btn": "_deleteNote",
            "keyup textarea.note": "_custNoteEntered"
        },

        _deleteNote: function (evt) {
            $(evt.currentTarget).closest(".note-item").remove();
        },

        _selectNote: function (evt) {
            var target = $(evt.currentTarget);
            if (target.hasClass("selected")) {
                target.removeClass("selected");
            } else {
                this.$(".note-item.selected").removeClass("selected");
                this.$("textarea.note").val("");
                target.addClass("selected");
            }
            $('.other-note textarea').val(target.find('span').text());
        },

        _custNoteEntered: function () {
            if ($.trim(this.$("textarea.note").val()) != "") {
                this.$(".note-item.selected").removeClass("selected");
            }
        },
        _saveNote: function () {
            var self = this, note = ($(".note-item.selected").size() > 0) ? this.$(".note-item.selected span").text() : $.trim(this.$("textarea.note").val()), jxhr;
            if (note.trim() != "") {
                POS.showLoading(true);
                jxhr = $.post("/printer/noteToBytes", {note: note, id: self.model.id});
                jxhr.done(function (response) {
                    if (response.success) {
                        self.trigger("noteSelected", {note: response.note, noteBytes: response.noteBytes});
                        if($('.cashier-print .cashierAmount .amountTitle-note').hasClass("hidden")){
                            $('.cashier-print .cashierAmount .amountTitle-note').removeClass('hidden');
                        }
                    }
                });
                jxhr.fail(function (response) {
                    console.log(response);
                });
                jxhr.always(function(){
                    POS.showLoading(false);
                });
            }
        },

        clear: function () {
            this.$(".note-item.selected").removeClass("selected");
            this.$("textarea.note").val("");
        }
    });
};

let exportedValue = main();
export default exportedValue;




// WEBPACK FOOTER //
// ./src/view/cashier/NoteSelectorView.js